export default "__VITE_ASSET__DJq$cozl__"